import { isTablet } from "../../helpers/mediaQueryHelper";

const BUSINESS_INTRO_LEVEL1_SELECTOR = ".js-business-intro--level-one";
const BUSINESS_INTRO_LEVEL3_SELECTOR = ".js-business-intro--level-three";
const HEADER_SELECTOR = ".js-heading";
const HEADER_WRAPPER_SELECTOR = ".js-heading-wrapper";

class BusinessIntroResizer {
    static attach(container) {
        /* eslint-disable-next-line no-unused-vars */
        const businessIntroResizer = new BusinessIntroResizer(container);
    }

    constructor(element) {
        this.wrapperElement = element;
        this.resizeLevelOne();
        this.resizeLevelThree();
        this.watchResize();
    }

    resizeLevelOne() {
        this.businessIntroLevelOneElements = this.wrapperElement.querySelectorAll(
            BUSINESS_INTRO_LEVEL1_SELECTOR
        );
        [...this.businessIntroLevelOneElements].forEach((element) => {
            let titles;
            const titleWrappers = element.querySelectorAll(HEADER_WRAPPER_SELECTOR);
            if (titleWrappers) {
                titles = titleWrappers;
            } else {
                titles = element.querySelectorAll(HEADER_SELECTOR);
            }
            if (titles) {
                this.matchTitleHeight(titles);
            }
        });
    }

    resizeLevelThree() {
        this.businessIntroLevelThreeElements = this.wrapperElement.querySelectorAll(
            BUSINESS_INTRO_LEVEL3_SELECTOR
        );
        [...this.businessIntroLevelThreeElements].forEach((element) => {
            const titles = element.querySelectorAll(HEADER_SELECTOR);
            if (titles) {
                this.matchTitleHeight(titles);
            }
        });
    }

    matchTitleHeight = (titles) => {
        [...titles].forEach((element) => {
            /* eslint-disable-next-line no-param-reassign */
            element.style.height = "auto";
        });

        if (!isTablet()) {
            const maxHeight = Math.max(...[...titles].map((title) => title.offsetHeight));

            [...titles].forEach((element) => {
                /* eslint-disable-next-line no-param-reassign */
                element.style.height = `${maxHeight}px`;
            });
        }
    };

    watchResize() {
        let inProcess = false;

        window.addEventListener(
            "resize",
            () => {
                if (!inProcess) {
                    inProcess = true;
                    window.requestAnimationFrame(() => {
                        this.resizeLevelOne();
                        this.resizeLevelThree();
                        inProcess = false;
                    });
                }
            },
            { passive: true }
        );
    }
}

export { BusinessIntroResizer };
